import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const FindWorkWrapper = styled.div`
    grid-template-areas:
        "header"
        "main";
    grid-template-rows: auto 80dvh;
    grid-template-columns: 1fr;
    grid-row-gap: 7rem;
    width: 80% !important;
    background: var(--b-wf-9-f-9-f-9, #f9f9f9);

    @media (${theme.breakpoints.tabletL}) {
        padding: 0 2rem;
    }

    @media (${theme.breakpoints.mobileL}) {
        grid-template-areas:
            "main"
            "sidenav";
        grid-template-rows: auto 1fr;
        grid-template-columns: none;

        grid-row-gap: 2rem;
        padding: 0 2rem;
    }
`;

export const RightSection = styled.div`
    grid-area: main;
    border-radius: 24px;
    position: relative;
    height: 100%;
    background-color: ${theme.colors.white};
    padding: 16px 14px;
    /* overflow-y: scroll; */

    @media (${theme.breakpoints.mobileL}) {
    }
`;
export const CardsColumn = styled.div`
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow-y: scroll;
    height: 66dvh;
    padding-right: 1rem;
`;

export const HorizontalCard = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 160px;
    padding: 10px;
    background-color: #fff;
    border-radius: 20px;
    gap: 17px;
    position: relative;
`;

export const CardLeft = styled.div`
    height: 100%;
`;

export const CardImage = styled.img`
    width: 140px;
    height: 140px;
    border-radius: 16px;
    background-position: center;
    object-fit: cover;
`;

export const CardContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const CardTitle = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
`;

export const CardChip = styled(Text)`
    padding: 4px 10px;
    border-radius: 20px;
    color: #fff;
    font-weight: 500;
    font-size: 11px;
    background-color: #ffbb0d;
`;

export const Info = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    svg {
        color: #00bbc7;
        font-size: 18px;
    }
    ${Text.Style} {
        margin-top: 1px;
    }
`;

export const AgencyImage = styled.img`
    width: 26px;
    height: 26px;
    border-radius: 50%;
    margin-right: 5px;
`;

export const CardRight = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: space-between;
    align-items: flex-end;

    svg:first-of-type {
        cursor: pointer;
        font-size: 16px;
    }
`;

export const Posted = styled(Text)`
    font-style: italic;
`;
